// Fuente única de verdad para datos de empresas (frontend).
// Si una empresa cambia de RUT, nombre, dirección o representante, se edita aquí.
// Las páginas y generadores de PDF/DOC importan los lookups de este módulo.

const normalize = (s) => (s || '')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toUpperCase();

// Indexado por código corto (FUGA, DAFA, INVE, TRAN). Las cookies usan este código en `selectedCard`.
export const empresasConfig = {
    DAFA: {
        codigo: 'DAFA',
        idEmpresa: 1,
        nombre: 'DAFA FACILITY SERVICES SPA',
        razonSocial: 'DAFA FACILITY SERVICES SPA',
        rutFormatted: '77.871.618-6',
        rutDigits: '778716186',
        logo: '/img/dafaLogo.png',
        logoPDF: '/img/dafaLogoPDF.png',
        color: [30, 58, 138],
        sidebarClass: 'sidebar-blue',
        popupTheme: 'theme-blue',
        representanteLegal: 'DIONISIO ALEJANDRO FUENTES ARANEDA',
        rutRepresentante: '15.221.206-2',
        domicilio: 'Avenida los Carrera 301, Seg. Piso',
        domicilioPDF: 'Los Carrera Poniente 301, piso 2',
        comuna: 'Concepción',
        ciudad: 'Concepción',
        email: 'administracion@idafa.cl',
    },
    FUGA: {
        codigo: 'FUGA',
        idEmpresa: 6,
        nombre: 'FUGAR GESTIÓN Y OBRAS',
        razonSocial: 'FUGAR GESTIÓN Y OBRAS',
        rutFormatted: '77.543.603-4',
        rutDigits: '775436034',
        logo: '/img/fugarLogo.png',
        logoPDF: '/img/fugarLogoPDF.png',
        color: [251, 146, 60],
        sidebarClass: 'sidebar-orange',
        popupTheme: 'theme-orange',
        representanteLegal: 'JARITZA JARELA GARCIAS RIFFO',
        rutRepresentante: '18.384.024-K',
        domicilio: 'Avenida los Carrera 301, Seg. Piso',
        domicilioPDF: 'Los Carrera Poniente 301, piso 2',
        comuna: 'Concepción',
        ciudad: 'Concepción',
        email: 'administracion@idafa.cl',
    },
    INVE: {
        codigo: 'INVE',
        idEmpresa: 5,
        nombre: 'GRUPO DE INVERSIONES DAFA SPA',
        razonSocial: 'GRUPO DE INVERSIONES DAFA SPA',
        rutFormatted: '78.400.681-6',
        rutDigits: '784006816',
        logo: '/img/idafaLogo.png',
        logoPDF: '/img/idafaLogoPDF.png',
        color: [16, 185, 129],
        sidebarClass: 'sidebar-green',
        popupTheme: 'theme-green',
        representanteLegal: '',
        rutRepresentante: '',
        domicilio: 'Avenida los Carrera 301, Seg. Piso',
        domicilioPDF: 'Los Carrera Poniente 301, piso 2',
        comuna: 'Concepción',
        ciudad: 'Concepción',
        email: 'administracion@idafa.cl',
    },
    NIDI: {
        codigo: 'NIDI',
        idEmpresa: 7,
        nombre: 'NIDIAM SPA',
        razonSocial: 'NIDIAM SPA',
        rutFormatted: '77.683.284-7',
        rutDigits: '776832847',
        logo: '/img/nidiamLogo.png',
        logoPDF: '/img/nidiamLogoPDF.png',
        color: [0, 189, 254],
        sidebarClass: 'sidebar-cyan',
        popupTheme: 'theme-cyan',
        representanteLegal: '',
        rutRepresentante: '',
        domicilio: 'Avenida los Carrera 301, Seg. Piso',
        domicilioPDF: 'Los Carrera Poniente 301, piso 2',
        comuna: 'Concepción',
        ciudad: 'Concepción',
        email: 'administracion@idafa.cl',
    },
    TRAN: {
        codigo: 'TRAN',
        idEmpresa: 4,
        nombre: 'TRANSPORTES EXTASIS SPA',
        razonSocial: 'TRANSPORTES EXTASIS SPA',
        rutFormatted: '77.612.657-8',
        rutDigits: '776126578',
        logo: '/img/extasisLogo.png',
        logoPDF: '/img/extasisLogo.png',
        color: [108, 117, 125],
        sidebarClass: 'sidebar-gray',
        popupTheme: 'theme-gray',
        representanteLegal: '',
        rutRepresentante: '',
        domicilio: 'Avenida los Carrera 301, Seg. Piso',
        domicilioPDF: 'Los Carrera Poniente 301, piso 2',
        comuna: 'Concepción',
        ciudad: 'Concepción',
        email: 'administracion@idafa.cl',
    },
};

// Índice por nombre normalizado. Incluye nombres legacy (empresas inactivas en BD)
// para que documentos viejos generados con esos nombres sigan resolviendo a la empresa actual.
const _byNombre = {};
Object.values(empresasConfig).forEach((e) => {
    _byNombre[normalize(e.nombre)] = e;
});
_byNombre[normalize('FUGAR SERVICIOS INDUSTRIALES SPA')] = empresasConfig.FUGA;
_byNombre[normalize('INVERSIONES DAFA SPA')] = empresasConfig.INVE;
_byNombre[normalize('INVERSIONES IDAFA SPA')] = empresasConfig.INVE;
_byNombre[normalize('EXTASIS TRANSPORTES SPA')] = empresasConfig.TRAN;

const _byId = {};
Object.values(empresasConfig).forEach((e) => {
    _byId[e.idEmpresa] = e;
});
_byId[2] = empresasConfig.FUGA;
_byId[3] = empresasConfig.INVE;

export const getEmpresaByCodigo = (codigo) => empresasConfig[codigo] || empresasConfig.DAFA;
export const getEmpresaByNombre = (nombre) => _byNombre[normalize(nombre)] || null;
export const getEmpresaById = (id) => _byId[id] || null;

export const getLogo = (codigo) => getEmpresaByCodigo(codigo).logo;
export const getLogoPDF = (codigo) => getEmpresaByCodigo(codigo).logoPDF;
export const getColor = (codigo) => getEmpresaByCodigo(codigo).color;
export const getRutFormatted = (codigo) => getEmpresaByCodigo(codigo).rutFormatted;
export const getNombre = (codigo) => getEmpresaByCodigo(codigo).nombre;

export default empresasConfig;
